<template>
  <div>
    <el-select :value="item.visitOrderStatus.statusId" class="w-100" size="medium" @change="onChangeStatus" :disabled="disabled">
      <el-option v-for="status in filteredStatuses" :key="status.id" :label="status.title" :value="status.id" />
    </el-select>

    <el-dialog :visible.sync="showChangeStatusDialog" @closed="fillForm" :before-close="beforeClose" class="dialog-w30">
      <el-form :model="form" :rules="rules" ref="form" :validate-on-rule-change="false" :key="form.status">
        <template v-if="currentStatusCode === ORDER_STATUS_CODES.CLAIM">
          <h2 class="text-center mt-0 mb-4">{{title}}</h2>

          <el-form-item prop="reasonId" :key="form.status">
            <el-select v-model="form.reasonId" filterable class="w-100" size="medium" placeholder="Выберите причину рекламации">
              <el-option v-for="item in reasonItems" :key="item.id" :label="item.displayName" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item prop="comment" class="mt-3">
            <el-input type="textarea"
                      :rows="4"
                      maxlength="200"
                      show-word-limit
                      placeholder="Комментарий"
                      v-model="form.comment"
                      resize="none"/>
          </el-form-item>

          <el-form-item prop="files" class="mt-3">
            <el-upload ref="upload" action="/" multiple
                       :show-file-list="false" :auto-upload="false"
                       :on-change="onChangeFiles">
              <el-button slot="trigger" icon="el-icon-plus" size="medium">
                Прикрепить файл
              </el-button>
            </el-upload>
          </el-form-item>

          <FilesBlock class="mt-4" :files="form.files" :isEdited="true" @onRemove="onRemoveFile" />
        </template>

        <template v-else-if="currentStatusCode === ORDER_STATUS_CODES.WASTED_VISIT">
          <h2 class="text-center mt-0 mb-4">{{title}}</h2>

          <el-form-item prop="reasonId">
            <el-select v-model="form.reasonId" filterable class="w-100" size="medium" placeholder="Выберите причину ложного выезда">
              <el-option v-for="item in reasonItems" :key="item.reasonId" :label="item.displayName" :value="item.reasonId" />
            </el-select>
          </el-form-item>

          <el-form-item prop="comment" class="mt-3">
            <el-input type="textarea"
                      :rows="4"
                      maxlength="200"
                      show-word-limit
                      placeholder="Комментарий"
                      v-model="form.comment"
                      resize="none"/>
          </el-form-item>

          <el-form-item prop="files" class="mt-3">
            <el-upload ref="upload" action="/" multiple
                       :show-file-list="false" :auto-upload="false"
                       :on-change="onChangeFiles">
              <el-button slot="trigger" icon="el-icon-plus" size="medium">
                Прикрепить файл
              </el-button>
            </el-upload>
          </el-form-item>

          <FilesBlock class="mt-4" :files="form.files" :isEdited="true" @onRemove="onRemoveFile" />
        </template>

        <template v-else-if="currentStatusCode === ORDER_STATUS_CODES.CANCELLED">
          <h2 class="text-center mt-0 mb-4">Причина отказа</h2>
          <el-form-item prop="reasonId">
            <el-select v-model="form.reasonId" filterable class="w-100" size="medium" placeholder="Выберите причину отказа">
              <el-option v-for="item in cancellations" :key="item.id" :label="item.displayName" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item prop="comment" class="mt-3">
            <el-input type="textarea"
                      :rows="4"
                      maxlength="200"
                      show-word-limit
                      placeholder="Комментарий"
                      v-model="form.comment"
                      resize="none"/>
          </el-form-item>
        </template>

        <template v-else>
          <h2 class="text-center mt-0 mb-4">Перевод заказа в статус - <br>"{{toStatusName}}"</h2>
        </template>

        <div class="row mt-4">
<!--          <div class="col-12 col-sm-6 pr-sm-0">-->
<!--            <el-button class="w-100" @click="showChangeStatusDialog = false">Отменить</el-button>-->
<!--          </div>-->
<!--          <div class="col-12 col-sm-6 mt-2 mt-sm-0">-->
<!--            <el-button class="w-100" type="primary" :loading="updateProgress" @click="onSaveStatus">Сохранить</el-button>-->
<!--          </div>-->
          <div class="col-12 col-sm-6 mt-2 mt-sm-0 mx-auto">
            <el-button class="w-100" type="primary" :loading="updateProgress || uploadFileCount>0" @click="onSaveStatus">Сохранить</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { ORDER_STATUS_CODES } from '@/commons/constants/orderStatusCodes';
import FilesBlock from '@/components/ui/FilesBlock';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FilesBlock,
  },
  data: () => ({
    ORDER_STATUS_CODES,
    showChangeStatusDialog: false,
    uploadFileCount: 0,
    form: {
      status: null,
      reasonId: null,
      comment: '',
      files: [],
    },
  }),
  created() {
    this.fetchStatuses();
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
      statuses: 'orders/statuses',
      cancellations: 'orderCancellationReasonsDrop/notArchivedItems',
      claims: 'claimReasonsDrop/notArchivedItems',
      orderStatusReasons: 'orderStatusReasonsDrop/notArchivedItems',
    }),
    currentStatusCode() {
      return this.statuses.find((status) => status.id === this.form.status)?.code || null;
    },
    title() {
      switch (this.currentStatusCode) {
        case ORDER_STATUS_CODES.CLAIM: return 'Причина рекламации';
        case ORDER_STATUS_CODES.WASTED_VISIT: return 'Ложный выезд';
        default: return '';
      }
    },
    reasonItems() {
      switch (this.currentStatusCode) {
        case ORDER_STATUS_CODES.CLAIM: return this.claims;
        case ORDER_STATUS_CODES.WASTED_VISIT: return this.orderStatusReasons;
        default: return '';
      }
    },
    // Фильтровать статусы заказа для перевода
    // если статус установлен на текущем заказе его отображать, если админ то видны все статусы,
    // если пользователь диспетчер, то статус ложный выезд скрыт для заказа в статусе Новый, Принят, В работе
    filteredStatuses() {
      const showWastedVisit = [ORDER_STATUS_CODES.NEW, ORDER_STATUS_CODES.ACCEPTED, ORDER_STATUS_CODES.IN_PROGRESS].includes(this.currentStatusCode);

      const isShowStatus = (code) => code === this.currentStatusCode
        || this.$isAccess(this.$userRoles.Admin)
        || (this.$isAccess(this.$userRoles.Dispatcher) && (code !== ORDER_STATUS_CODES.WASTED_VISIT || showWastedVisit));
      return this.statuses.filter((s) => isShowStatus(s.code));
    },
    rules() {
      switch (this.currentStatusCode) {
        case ORDER_STATUS_CODES.CLAIM:
          return {
            reasonId: [
              { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
            ],
            files: [
              { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
            ],
          };
        case ORDER_STATUS_CODES.WASTED_VISIT:
          return {
            reasonId: [
              { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
            ],
          };
        case ORDER_STATUS_CODES.CANCELLED:
          return {
            reasonId: [
              { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
            ],
          };
        default: return {};
      }
    },
    toStatusName() {
      return this.statuses.find((s) => s.code === this.currentStatusCode)?.title || '';
    },
  },
  methods: {
    ...mapActions({
      fetchStatuses: 'orders/fetchStatuses',
      fetchCancellations: 'orderCancellationReasonsDrop/fetchItems',
      fetchClaims: 'claimReasonsDrop/fetchItems',
      fetchOrderStatusReasons: 'orderStatusReasonsDrop/fetchItems',
      updateStatus: 'orders/updateStatus',
      uploadFileGetUrl: 'files/uploadFileGetUrl',
    }),
    fillForm() {
      this.form.status = this.item.visitOrderStatus.statusId;
      this.form.reasonId = null;
      this.form.comment = '';
      this.form.files = [];
    },
    onChangeStatus(value) {
      this.form.status = value;
      this.showChangeStatusDialog = true;
      switch (this.currentStatusCode) {
        case ORDER_STATUS_CODES.CLAIM:
          this.fetchClaims({ includeArchived: false });
          break;
        case ORDER_STATUS_CODES.WASTED_VISIT:
          this.fetchOrderStatusReasons({ includeArchived: false });
          break;
        case ORDER_STATUS_CODES.CANCELLED:
          this.fetchCancellations({ includeArchived: false });
          break;
        default:
      }
    },

    beforeClose(done) {
      if (!this.updateProgress) {
        done();
      }
    },

    onChangeFiles(evt) {
      this.uploadFileCount += 1;
      this.uploadFileGetUrl({ file: evt.raw })
        .then((file) => {
          this.form.files.push(file);
        })
        .finally(() => {
          this.uploadFileCount -= 1;
        });
    },

    onRemoveFile(file) {
      const fileIndex = this.form.files.findIndex((f) => f.id === file.id);
      if (fileIndex > -1) {
        this.form.files.splice(fileIndex, 1);
      }
    },

    getDataForm() {
      switch (this.currentStatusCode) {
        case ORDER_STATUS_CODES.CLAIM:
        case ORDER_STATUS_CODES.CANCELLED:
        case ORDER_STATUS_CODES.WASTED_VISIT:
          return this.form;
        default:
          return {
            status: this.form.status,
          };
      }
    },

    onSaveStatus() {
      const { visitOrderId: id } = this.item;
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = this.getDataForm();

          this.updateStatus({ id, data }).then(() => {
            this.showChangeStatusDialog = false;
          });
        }
      });
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
